<app-record-pagination
  [selectedRssItem]="selectedRssItem"
  [rssItemSelectedFromUrl]="rssItemSelectedFromUrl"
  [state]="state"
  [rhId]="rhId"
  [showResourceDetails]="showResourceDetails"
  [record]="record"
  [showTopNavigation]="showTopNavigation"></app-record-pagination>

<div class="wrapper" *ngIf="loading">
  <mat-spinner [diameter]="120"></mat-spinner>
</div>

<div *ngIf="!loading" class="record__wrapper">
  <div class="record__left">
    <div class="record__left__img">
      <ng-container *ngIf="selectedRssItem then rssItemCover else recordCover"></ng-container>
    </div>

    <ng-template #recordCover>
      <opac-record-cover [coverUrl]="recordCoveImageUrl" [icon]="record.icon"></opac-record-cover>
    </ng-template>

    <ng-template #rssItemCover>
      <opac-record-cover [coverUrl]="selectedRssItem.cover" [icon]="selectedRssItem.icon"></opac-record-cover>
    </ng-template>

    <div class="left-details">
      <ng-container *ngIf="showResourceCopies">
        <div class="resource" *ngIf="showCopies">
          <p class="label">{{ 'info.totalCopies' | translate }}</p>
          <span class="value">{{ availability?.totalCopies }}</span>
        </div>

        <div class="resource" *ngIf="showAvailableCopies">
          <p class="label">{{ 'info.availableCopies' | translate }}</p>
          <span class="value">{{ availability?.availableCopies }}</span>
        </div>
      </ng-container>

      <div class="resource" *ngIf="availability?.holdsQueueSize > 0">
        <p class="label">{{ 'info.holds' | translate }}</p>
        <span class="value">{{ availability.holdsQueueSize }}</span>
      </div>

      <div class="resource" *ngIf="!availability?.availableCopies && availability?.estimatedWait >= 0">
        <p class="label">{{ 'info.holdEta' | translate }}</p>
        <span class="value">
          <ng-container *ngIf="availability?.estimatedWait > 0 else lessThanADay">
            {{ availability.estimatedWait }}
            <span [ngPlural]="availability.estimatedWait">
              <ng-template ngPluralCase="=1">{{ 'general.singularDay' | translate }}</ng-template>
              <ng-template ngPluralCase="other">{{ 'general.pluralDay' | translate }}</ng-template>
            </span>
          </ng-container>

          <ng-template #lessThanADay> {{ 'general.lessThanADay' | translate }} </ng-template>
        </span>
      </div>

      <div class="resource" *ngIf="showTotalCheckouts">
        <p class="label">{{ 'info.totalCheckouts' | translateByCustomerType:customerType.dbValue }}</p>
        <span class="value">{{ record.totalCheckouts }}</span>
      </div>

      <div class="resource" *ngIf="showTotalViews">
        <p class="label">{{ 'info.visits' | translate }}</p>
        <span class="value">{{ record.totalViews }}</span>
      </div>
    </div>
  </div>

  <div class="record__right">
    <a *ngIf="physicalParentId" class="physical-parent-link" [routerLink]="['/info', physicalParentId]"
      >{{ physicalParentTitle }}</a
    >
    <div class="record-title">
      <div #accessibilityAutofocus class="accessibility-focus-element" tabindex="0"></div>
      <h1 *ngIf="selectedRssItem" class="record__right__title" tabindex="0" #recordTitle>
        {{ selectedRssItem.title }}
      </h1>
      <h1 *ngIf="!selectedRssItem" class="record__right__title" tabindex="0" [appRecordTitle]="record" #recordTitle>
        {{ !record.title ? this.physicalParentTitle : '' }}
      </h1>
      <button *ngIf="issueDate" class="record-issueDate">{{ issueDate | parseDate }}</button>
    </div>

    <div class="record__right__subtitle" *ngIf="!showItemsSection || selectedRssItem">
      <span class="subtitle__link" *ngIf="selectedRssItem" (click)="unselectRssItem()">{{ record.title }}</span>
      <span class="subtitle__bullet" *ngIf="selectedRssItem && record.author"> · </span>
      <div class="author subtitle__link" *ngIf="record.author">
        <a routerLink="/results" [queryParams]="searchByAuthor(record.author)">{{ record.author }}</a>
      </div>
      <button
        mat-flat-button
        *ngIf="showFollowAuthorButton"
        class="warn transparent follow-author-button"
        [attr.aria-label]="'user.lists.followAuthor' | translate"
        (click)="followAuthor()">
        {{ 'user.lists.followAuthor' | translate }}
      </button>

      <button
        mat-flat-button
        *ngIf="showUnfollowAuthorButton"
        class="warn transparent follow-author-button"
        [attr.aria-label]="'lists.unfollow' | translate"
        (click)="unfollowAuthor()">
        {{ 'lists.unfollow' | translate }}
      </button>
    </div>

    <app-record-interactions *ngIf="!selectedRssItem" [record]="record" [rating]="rating"></app-record-interactions>

    <div class="record__right__buttons">
      <app-record-buttons
        from="RECORD_SCREEN"
        [record]="record"
        [issueDate]="issueDate"
        [rssItem]="selectedRssItem"
        [config]="buttonsConfig"
        [callback]="showGalleryCallback"
        [isInfoPage]="true"></app-record-buttons>

      <div class="tables-container">
        <app-physical-records-table
          *ngIf="showPhysicalAvailabilityTable && physicalAvailabilityItems.length > 0"
          [record]="record"
          [physicalAvailabilityItems]="physicalAvailabilityItems"></app-physical-records-table>

        <app-physical-lower-level-table
          *ngIf="showLowerLevelItemsTable && physicalLowerLevelItems.length > 0"
          [physicalLowerLevelItems]="physicalLowerLevelItems"></app-physical-lower-level-table>

        <app-fascicle-records-table
          *ngIf="showFascicleAvailabilityTable && fascicleAvailabilityItems.length > 0"
          [recordTitle]="record.title"
          [fascicleAvailabilityItems]="fascicleAvailabilityItems"></app-fascicle-records-table>
      </div>
    </div>

    <div class="parent-wrapper" [class.full]="descExpanded()">
      <div class="record__right__description" [class.full]="descExpanded()" [class.larger]="images.length">
        <app-image-gallery
          *ngIf="showGallery"
          from="RECORD_SCREEN"
          [images]="images"
          [recordId]="record.id"
          [placeholder]="false"></app-image-gallery>

        <div
          class="description-container"
          tabindex="0"
          [innerHTML]="(selectedRssItem && selectedRssItem.description) ? selectedRssItem.description : record.description"></div>

        <div class="description-wrapper">
          <opac-button
            (click)="descExpanded.set(!descExpanded())"
            [ariaLabel]="descExpandedLabel() | translate" [opacTooltip]="descExpandedLabel() | translate">
            <opac-icon slot="only-icon" icon="navigate_downward"></opac-icon>
          </opac-button>
        </div>
      </div>
    </div>

    <div class="record__right__electronic_location" *ngIf="record.electronicLocation">
      <div *ngFor="let item of record.electronicLocation">
        <a [href]="item.uri" target="_blank" rel="noopener">{{ item.label }}</a>
        <span class="odilo-icon">external_link</span>
      </div>
    </div>

    <div class="record__right__subjects" *ngIf="record.subjects.length || isPPU ">
      <button mat-flat-button tabindex="-1" *ngFor="let subject of subjects">
        <a [routerLink]="['/results']" [queryParams]="buildTopicFacetQuery(subject.term)">{{ subject.label }}</a>
      </button>
      <button mat-flat-button tabindex="-1" *ngIf="isPPU">
        <a [routerLink]="['/results']" [queryParams]="buildPpuFacetQuery()">{{ 'info.simultaneousUse' | translate }}</a>
      </button>
    </div>

    <div class="metadata-details">
      <app-metadata-info *ngFor="let metadata of record?.metadata" [metadata]="metadata"></app-metadata-info>
    </div>

    <div class="resource-details hide-desktop" *ngIf="showResourceDetails">
      <ng-container *ngIf="showResourceCopies">
        <div class="resource" *ngIf="showCopies">
          <p class="label">{{ 'info.totalCopies' | translate }}</p>
          <span class="value">{{ availability?.totalCopies }}</span>
        </div>

        <div class="resource" *ngIf="showAvailableCopies">
          <p class="label">{{ 'info.availableCopies' | translate }}</p>
          <span class="value">{{ availability?.availableCopies }}</span>
        </div>
      </ng-container>

      <div class="resource" *ngIf="availability?.holdsQueueSize > 0">
        <p class="label">{{ 'info.holds' | translate }}</p>
        <span class="value">{{ availability.holdsQueueSize }}</span>
      </div>

      <div class="resource" *ngIf="availability?.estimatedWait > 0">
        <p class="label">{{ 'info.holdEta' | translate }}</p>
        <span class="value">{{ availability.estimatedWait }}</span>
      </div>

      <div class="resource" *ngIf="showTotalCheckouts">
        <p class="label">{{ 'info.totalCheckouts' | translateByCustomerType:customerType.dbValue }}</p>
        <span class="value">{{ record.totalCheckouts }}</span>
      </div>

      <div class="resource" *ngIf="showTotalViews">
        <p class="label">{{ 'info.visits' | translate }}</p>
        <span class="value">{{ record.totalViews }}</span>
      </div>
    </div>

    <div class="accessibility-metadata">
      <span class="accessibility-metadata-title">{{ 'info.accessibility_metadata.title' | translate }}</span>

      <div *ngIf="record.accessibilityMetadata && record.accessibilityMetadata.length > 0" class="accessibility-metadata-content">
        <app-metadata-info *ngFor="let metadata of record?.accessibilityMetadata" [metadata]="metadata" [enableFullWidth]="true"></app-metadata-info>
      </div>

      <div *ngIf="!record.accessibilityMetadata || record.accessibilityMetadata.length <= 0">
        <span>{{ 'info.accessibility_metadata.no_data' | translate }}</span>
      </div>
    </div>

    <div class="record__right__subjects record__right__subjects--experiences" *ngIf="record?.associatedExperiences">
      <p class="record__right__subjects__title">{{ bookclubName }}</p>
      <button mat-flat-button tabindex="-1" *ngFor="let item of record.associatedExperiences">
        <a [attr.aria-label]="item.title" [routerLink]="['/info', getExperienceLink(item.title, item.recordId)]"
          >{{ item.title }}</a
        >
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="showItemsSection">
  <app-container-record-items
    [record]="record"
    [parentFocused]="selectedRssItem === null"
    (selected)="selectRssItem($event)"></app-container-record-items>
</ng-container>

<div class="info__bottom">
  <ng-container *ngIf="showUserRecommendations && (userRecommendations$ | async) as items">
    <app-slider
      *ngIf="items.length && user"
      [items]="items"
      [collection]="dummyCollection"
      [title]="'collections.recommendations.user'"
      (selected)="onItemSelected($event)"></app-slider>
  </ng-container>

  <ng-container *ngIf="(relatedItems$ | async) as items">
    <app-slider
      *ngIf="items.length"
      [items]="items"
      [collection]="dummyCollection"
      [title]="'collections.recommendations.related'"
      (selected)="onItemSelected($event)"></app-slider>
  </ng-container>

  <!-- <ng-container *ngIf="(alsoCheckedOut$ | async) as items">
    <app-slider *ngIf="items.length"
                [items]="items"
                [collection]="dummyCollection"
                [title]="'collections.recommendations.checkedout'"
                (selected)="onItemSelected($event)"></app-slider>
  </ng-container> -->

  <app-rating-block *ngIf="rating" [rating]="rating"></app-rating-block>

  <div *ngIf="user !== null" class="comments-container">
    <opac-button *ngIf="openTextareaId() !== textareaId()" (click)="openRootComment()">
      <opac-icon icon="add" slot="start"></opac-icon>
      {{ 'comments.addComment' | translate }}
    </opac-button>

    <app-edit-comment *ngIf="openTextareaId() === textareaId()" [submitLabel]="'comments.actions.add'" [textareaId]="textareaId()" (cancelReply)="cancelRootComment()" (submitReply)="submitRootComment($event)"></app-edit-comment>
  </div>

  <opac-divider class="comments-divider"></opac-divider>

  <div class="comments-container">
    <span *ngIf="!isLoadingComments()">{{ 'comments.reviews.length' | translate:{ count: commentsCount() } }}</span>

    <app-comment-skeleton *ngIf="isCreatingComment()"></app-comment-skeleton>

    <app-comment *ngFor="let comment of comments(); trackBy: trackCommentsFn" [comment]="comment" [recordId]="record.id"></app-comment>

    <ng-container *ngIf="isLoadingComments()">
      <app-comment-skeleton></app-comment-skeleton>
      <app-comment-skeleton></app-comment-skeleton>
      <app-comment-skeleton></app-comment-skeleton>
      <app-comment-skeleton></app-comment-skeleton>
      <app-comment-skeleton></app-comment-skeleton>
    </ng-container>

    <opac-infinite-scroll [disabled]="commentsLastEvaluatedKey() === null" (load)="loadMoreComments()"></opac-infinite-scroll>
  </div>
</div>
